import { Accordion, AccordionDetails, AccordionSummary, Box, Grid, Typography } from '@mui/material';
import React from 'react';
import { ExpandMore } from '@mui/icons-material';
import { Layout10Styles } from '../../styles/layout_10';
import { GeneralContentProps } from '../../interfaces/generalContentProps';
import { GeneralContentStyles } from '../../styles';
import ReactHtmlParser from 'html-react-parser';

const GeneralContentLayout10 = (props: GeneralContentProps): React.JSX.Element => {
  const { items, title, titleColor, backgroundColor, id } = props;
  const { classes } = GeneralContentStyles({ titleColor, backgroundColor });
  const { classes: layout10Classes } = Layout10Styles(props);

  return (
    <Grid container className={`${layout10Classes.gridContainer} ${classes.eventContainer}`} id={id}>
      <Box>
        <Typography className={classes.title}>{title}</Typography>
      </Box>

      <Box className={layout10Classes.accordionWrapper}>
        {items &&
          items.map((item, index) => {
            return (
              <Accordion
                key={item.title}
                variant="outlined"
                defaultExpanded={index === 0}
                className={`${layout10Classes.accordion} 
                }`}>
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  className={`${layout10Classes.accordionSummary} ${layout10Classes.positionRelative}`}>
                  <Box>{item.title}</Box>
                </AccordionSummary>
                <AccordionDetails className={layout10Classes.accordionDetails}>
                  <Box>{ReactHtmlParser(item.description)}</Box>
                </AccordionDetails>
              </Accordion>
            );
          })}
      </Box>
    </Grid>
  );
};

export default GeneralContentLayout10;
